import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, tap } from 'rxjs';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  constructor(private spinnerService: NgxSpinnerService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinnerService.show();
    return next
      .handle(req).pipe(
        tap({
          next: (event) => {
            if (event instanceof HttpResponse) {
              this.spinnerService.hide();
            }
          },
          error: (error) => {
            this.spinnerService.hide();
          }
        })
      )
  }
}
